import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-aim",
  "use": "foquz-icon-aim-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-aim\"><circle r=\"1\" transform=\"matrix(1 0 0 -1 6 6)\" fill=\"#8EA6FF\" /><path d=\"M6 3.5V1m0 10V8.5M3.5 6H1m10 0H8.5m1.25 0a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z\" stroke=\"#8EA6FF\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol